/* [PATCH nastavitve-zavihki v1] preseljeno 1:1 iz ProfilPage.tsx (637-679).
   [PATCH placano-profil-fe v1] — inline iskalnik partnerja (privzeti placnik = delavec)
   za kartico "Racun = placan"; uporablja ga tudi kartica "Zbirni kupec". */
import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';

export function PlacnikPartnerVnos({ companyId, partnerId, partnerNaziv, onIzbira }: {
  companyId: string; partnerId?: string; partnerNaziv?: string;
  onIzbira: (partner_id: string, partner_naziv: string) => void;
}) {
  const [partnerji, setPartnerji] = useState<any[]>([]);
  const [q, setQ] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (companyId) api.get(`/sifranti/partnerji/${companyId}?limit=5000`).then(r => setPartnerji(r.data || [])).catch(() => {});
  }, [companyId]);
  const prikaz = q !== null ? q : (partnerNaziv || '');
  const filtered = q === null ? [] : partnerji.filter((p: any) =>
    (p.name || '').toLowerCase().includes(q.toLowerCase()) || (p.tax_number || '').includes(q)
  ).slice(0, 10);
  return (
    <div className="relative">
      <input
        value={prikaz}
        onChange={e => { setQ(e.target.value); setOpen(true); }}
        onFocus={() => { setQ(''); setOpen(true); }}
        onBlur={() => setTimeout(() => { setQ(null); setOpen(false); }, 200)}
        placeholder="Išči po imenu ali davčni..."
        className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition"
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {filtered.map((p: any) => (
            <button key={p.id} onMouseDown={() => { onIzbira(String(p.id), String(p.name || '')); setQ(null); setOpen(false); }}
              className="w-full px-3 py-2 text-left text-sm hover:bg-blue-50 dark:hover:bg-gray-700">
              <span className="text-gray-900 dark:text-white">{p.name}</span>
              <span className="ml-2 text-xs text-gray-400 font-mono">{p.tax_number || ''}</span>
            </button>
          ))}
        </div>
      )}
      {partnerId ? (
        <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Izbran: <span className="text-gray-900 dark:text-white font-medium">{partnerNaziv}</span></div>
      ) : (
        <div className="mt-1 text-xs text-amber-600 dark:text-amber-400">Plačnik še ni izbran</div>
      )}
    </div>
  );
}
